/* eslint-disable import/prefer-default-export */

import {
  GET_DISCUSSION_MESSAGES,
  GET_DISCUSSION_MESSAGES_SUCCESS,
  GET_DISCUSSION_MESSAGES_FAIL,
  RESET_DISCUSSION_MESSAGES,
} from '../constants';
import { buildQuery } from '../helpers';

export function getMessages(id, params = { page: 1, perPage: 50 }) {
  const query = buildQuery(params);

  return {
    types: [
      GET_DISCUSSION_MESSAGES,
      GET_DISCUSSION_MESSAGES_SUCCESS,
      GET_DISCUSSION_MESSAGES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/discussions/${id}/messages/?${query}`, {
        method: 'GET',
      }),
  };
}

export function resetMessages() {
  return {
    type: RESET_DISCUSSION_MESSAGES,
  };
}
